<template>
  <div class="all">

    <div  v-if="flag"  id="tablePrint" class="table_print" style="padding: 0px 10px;font-size: 12px;text-align: left;padding-bottom:30px">
      <div v-if="orderObj.printHeader" style="font-size:20px;font-weight: bold;">{{orderObj.printHeader}} </div>

      <div style="text-align:center;font-size:26px;font-weight: bold;margin-bottom:10px">【{{printnameB}}】</div>
      <div style="text-align:center;font-size:26px;font-weight:bold;margin-bottom:10px">【{{orderObj.restaurant}} {{orderObj.mealTableNum}}】</div>
      <hr style="border:none;border-top:1px dashed #999;margin:6px 0px" />
      <div style="display:flex; flex-wrap:wrap; font-size:12px;">
        <div style="font-size:12px; width:50%;margin-bottom:5px">单号:{{orderObj.orderNum}}</div>
        <div style="font-size:12px;width:50%;margin-bottom:5px">人数:{{orderObj.peopleCount}}</div>
        <div style="font-size:12px;width:40%">点餐员:{{orderObj.userName}}</div>

        <div style="font-size:12px;width:60%;" v-if="orderObj.orderMenusMap.length">日期:{{orderObj.orderMenusMap[0].createDate}}</div>
        <div style="font-size:12px;width:60%;" v-else>日期:{{orderObj.orderTime}}</div>
      </div>
      <hr style="border:none;border-top:1px dashed #999;margin:6px 0px" />

      <div class="table" style="padding-bottom:20px">

        <div v-for="(v,i) in orderObj.orderMenusMap" :key="i" style="padding:10px 0;">
          <div style="display:flex;justify-content: space-between;font-weight:bold;">
            <div style="font-size:20px;">
              {{v.dishesName}}
            </div>
            <div style="font-size:20px;">
            {{orderObj.printHeader=='【退菜】' ? '-' :''}}  {{v.quantity.toFixed(2)}}{{v.unitName}}
            </div>
          </div>
          <div style="font-size:14px;padding-top:8px" v-if="v.remark">要求：{{v.remark}} </div>

        </div>
      </div>

      <div style="height:2px;width:100%"></div>
      <hr style="border:none;border-top:1px dashed #999;margin:6px 0px" />
      <div v-if="orderObj.remark" style="font-size:20px;font-weight: bold;">
        <div> 整单备注：{{orderObj.remark}}</div>
        <hr style="border:none;border-top:1px dashed #999;margin:6px 0px" />

      </div>
    </div>
    <div  v-if="!flag" id="tablePrint" class="table_print" style="padding: 0px 10px;font-size: 12px;text-align: left;padding-bottom:30px">
      <div v-if="orderObj.printHeader" style="font-size:20px;font-weight: bold;">{{orderObj.printHeader}} </div>

      <div style="text-align:center;font-size:20px;font-weight: bold;margin-bottom:10px">【{{printnameB}}】</div>
      <div style="text-align:center;font-size:20px;font-weight:bold;margin-bottom:10px">【{{orderObj.restaurant}} {{orderObj.mealTableNum}}】</div>
      <hr style="border:none;border-top:1px dashed #999;margin:6px 0px" />
      <div style="display:flex; flex-wrap:wrap; font-size:12px;">
        <div style="font-size:10px; width:40%;margin-bottom:5px">单号:{{orderObj.orderNum}}</div>
        <!-- <div style="font-size:12px;width:40%;margin-bottom:5px">桌号:{{orderObj.mealTableNum}}</div> -->
        <div style="font-size:10px;width:60%;margin-bottom:5px">人数:{{orderObj.peopleCount}}</div>
        <div style="font-size:10px;width:40%">点餐员:{{orderObj.userName}}</div>

        <div style="font-size:10px;width:60%;">日期:{{orderObj.orderTime}}</div>
      </div>
      <hr style="border:none;border-top:1px dashed #999;margin:6px 0px" />

      <div class="table" style="padding-bottom:20px">

        <div v-for="(v,i) in orderObj.orderMenusMap" :key="i" style="padding:10px 0;">
          <div style="display:flex;justify-content: space-between;font-weight:bold;">
            <div style="font-size:20px;">
              {{v.dishesName}}
            </div>
            <div style="font-size:20px;">
            {{orderObj.printHeader=='【退菜】' ? '-' :''}}     {{v.quantity.toFixed(2)}}{{v.unitName}}
            </div>
          </div>
          <div style="font-size:12px;padding-top:8px" v-if="v.remark">要求：{{v.remark}} </div>

        </div>
      </div>

      <div style="height:2px;width:100%"></div>
      <hr style="border:none;border-top:1px dashed #999;margin:6px 0px" />
      <div v-if="orderObj.remark" style="font-size:20px;font-weight: bold;">
        <div> 整单备注：{{orderObj.remark}}</div>
        <hr style="border:none;border-top:1px dashed #999;margin:6px 0px" />

      </div>
    </div>
  </div>
</template>
<script>
import getLodop from '../../utils/Lodopfuncs'

export default {
  props: {
    orderObj: {
      type: Object
    },

  },
  data() {
    return {
      printnameB: "凉菜",

      name: "",
      tableList: [],
      printlists: [],
      type: "",
      remark: undefined,
      printnumber: 0,
      stampumber: 0,
      flag:false
    }
  },
  watch: {


  },
  computed: {

  },
  mounted() {
    this.$bus.$on('printName', val => {
      this.printnameB = val
    })
  },
  created() {
    this.getTime()


  },
  methods: {


    getTime() {

      let date = new Date();
      let y = 1900 + date.getYear();
      let m = "0" + (date.getMonth() + 1);
      let d = "0" + date.getDate();
      let h = "0" + date.getHours();
      let mm = "0" + date.getMinutes();
      let s = date.getSeconds();
      this.time = y + "-" + m.substring(m.length - 2, m.length) + "-" + d.substring(d.length - 2, d.length) + " " + h.substring(h.length - 2, h.length) + ":" + mm.substring(mm.length - 2, mm.length);
        let url = this.api.printModelType + '?modelType=B'
        let methods = 'get'

        this.$axios({url,methods}).then(res=>{
            // console.log(res);
            if (res.data.status == 0 && res.data.data) {
                this.flag=true

            }
       })
    },


    GetPrinter() {
      //获取当前打印机

      LODOP = getLodop();

      var iCount = LODOP.GET_PRINTER_COUNT();

      var PData = [];

      for (var i = 0; i < iCount; i++) {
        PData.push(LODOP.GET_PRINTER_NAME(i));
      }

      return PData;
    },

    getPrint() {
      if (this.orderObj.code) {

        this.$nextTick(() => {

          this.todoPrintS()
        })
      } else {
        setTimeout(() => {
          this.todoPrintS()
        }, 1000);
      }

    },
    todoPrintS() {

      // this.printlists = [...list]
      // this.name = name
      const LODOP = getLodop()
      console.log(LODOP,'lodop-----开始打印')
      if (LODOP) {

        //获取打印内容
        var strFormHtml = `<body>` + document.getElementById('tablePrint').innerHTML + '</body>'   //获取打印内容
        LODOP.PRINT_INIT('') //初始化
        LODOP.SET_PRINT_PAGESIZE(1, 60, 0, '') //设置纵向
        // LODOP.SET_PRINT_PAGESIZE(1, 0, 0, 'A4')  //设置纵向
        LODOP.ADD_PRINT_HTM('5', '20', '90%', '80%', strFormHtml)
        // LODOP.SET_PRINT_STYLEA(0, "Offset2Top", 10)
        // LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", 0)
        // LODOP.SET_PRINT_STYLEA(0, "TextNeatRow", true)
        LODOP.SET_PREVIEW_WINDOW(2, 0, 0, 800, 800, '')//设置预览窗口模式和大小
        LODOP.SET_PRINT_MODE("NOCLEAR_AFTER_PRINT", true);//设置打印完毕不清理打印信息


        var PData = this.GetPrinter();

        console.log(this.printnameB,'this.printnameB-------------------')


        if (PData.length) {

          if (PData.indexOf(this.printnameB) !== -1) {
            console.log('打印名字', this.printnameB);
            LODOP.SET_PRINTER_INDEXA(this.printnameB);//设置某个打印机
            LODOP.PRINT()

          }

          this.printlists = []



        } else {
          this.$notify.error({
            title: '当前电脑无打印机'
          })
        }

        // LODOP.SET_PRINT_COPIES(2)

        // LODOP.SET_PRINTER_INDEXA(this.printnameA);//设置某个打印机
        // LODOP.PRINT()


      }



    },

  }

}
</script>
<style lang="scss" scoped>
#tablePrint {
  padding: 10px 15px;
  font-size: 12px;
  text-align: left;
}

.shopName {
  text-align: center;
}
.boxName {
  text-align: center;
}
.label {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.btn {
  width: 100%;
  display: flex;
  justify-content: space-between;
  /deep/ .el-button {
    width: 160px;
  }
}
</style>